import { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'motion/react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'elevenlabs-convai': {
        'agent-id': string;
        children?: React.ReactNode;
      };
    }
  }
}

interface VoiceAssistantWidgetProps {
  isVisible: boolean;
}

export default function VoiceAssistantWidget({ isVisible }: VoiceAssistantWidgetProps) {
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // Check if script is already loaded to avoid duplicates
    if (scriptLoaded.current || document.querySelector('script[src*="convai-widget-embed"]')) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
    script.async = true;
    script.type = 'text/javascript';

    script.onload = () => {
      scriptLoaded.current = true;
      console.log('ElevenLabs Convai widget loaded successfully');
    };

    script.onerror = () => {
      console.error('Failed to load ElevenLabs Convai widget script');
    };

    document.head.appendChild(script);

    return () => {

























































      // Note: We don't remove the script on cleanup as it might be used by other components
    };}, []);return <AnimatePresence data-id="gukfkk5d1" data-path="src/components/widgets/VoiceAssistantWidget.tsx">
      {isVisible && <motion.div initial={{ opacity: 0, y: 20, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20, scale: 0.8 }} transition={{ duration: 0.3, type: "spring", stiffness: 300, damping: 25 }} className="fixed bottom-6 right-6 z-50" data-id="rsbdloqy5" data-path="src/components/widgets/VoiceAssistantWidget.tsx">

          {/* Widget placeholder - agent ID should be configured via environment variables */}
          <elevenlabs-convai agent-id="" data-id="0hex6z2cm" data-path="src/components/widgets/VoiceAssistantWidget.tsx">
            <div className="p-4 bg-white rounded-lg shadow-lg" data-id="kl1bns1x8" data-path="src/components/widgets/VoiceAssistantWidget.tsx">
              <p className="text-gray-600" data-id="ve7apkrvh" data-path="src/components/widgets/VoiceAssistantWidget.tsx">Voice Assistant - Configure agent ID to enable</p>
            </div>
          </elevenlabs-convai>
        </motion.div>}
    </AnimatePresence>;}